<template>
    <div id="deliveryroutedetailsPage">
        <div class="top-buttons">
            <ui5-button @click="$router.push('/deliveryroutes')">
                {{ trans('pages.delivery_route_details.back_to_rounds') }}
            </ui5-button>
        </div>
        <div v-if="route">
            <h3>{{ trans('pages.delivery_route_details.details') }}</h3>
            <p>
                <b>{{ trans('pages.delivery_route_details.round_id') }}</b>
                <span>{{ route.id }}</span>
            </p>
            <p>
                <b>{{ trans('pages.delivery_route_details.name') }}</b>
                <span>{{ route.name }}</span>
            </p>
            <p>
                <b>{{ trans('pages.delivery_route_details.description') }}</b>
                <span>{{ route.description }}</span>
            </p>
        </div>

        <ui5-table v-if="route">
            <ui5-table-column slot="columns" :popin-text="trans('pages.delivery_route_details.customer_id')">
                <span>{{ trans('pages.delivery_route_details.customer_id') }}</span>
            </ui5-table-column>
            <ui5-table-column slot="columns" :popin-text="trans('pages.delivery_route_details.customer_name')">
                <span>{{ trans('pages.delivery_route_details.customer_name') }}</span>
            </ui5-table-column>

            <ui5-table-row :key="date.customerId" v-for="date in datesList">
                <ui5-table-cell>{{ date.customerId }}</ui5-table-cell>
                <ui5-table-cell>{{ date.customerName }}</ui5-table-cell>
            </ui5-table-row>
        </ui5-table>
    </div>
</template>
<script>
import deliveryRoutesApi from '../api/deliveryRoutes';
import customerApi from '../api/customer';
import IdParamMixin from '../mixins/id-param';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    data() {
        return {
            route: null,
            datesList: null,
        };
    },
    methods: {
        load() {
            const routeId = this.$route.params.id;
            this.route = null;
            this.datesList = null;

            deliveryRoutesApi.fetchRoute(routeId).then((request) => {
                this.route = request.data.data;
            });

            customerApi.listCustomersForRoute(routeId).then((request) => {
                this.datesList = request.data.data;
            });
        },
    },
};
</script>
